<template>
  <v-app>
    <SnackBar />
    <PdfViewerDialog />
    <AccountConflictDialog />
    <router-view />
  </v-app>
</template>

<script>
import SnackBar from "./components/SnackBar/SnackBar.vue";
import PdfViewerDialog from "./components/common/PdfViewerDialog.vue";
import AccountConflictDialog from "./components/common/AccountConflictDialog.vue";

export default {
  components: { SnackBar, PdfViewerDialog, AccountConflictDialog },
  name: "App",

  data: () => ({
    //
  }),
};
</script>
<style media="screen" lang="scss">
@import "~vue-wysiwyg/dist/vueWysiwyg.css";
@import "./app_css/global.scss";
/* Design tokens first — every rule below reads var(--o-*) from here. */
@import "./app_css/tokens.scss";
@import "./app_css/dashboard.scss";
@import "./app_css/dash-soft.scss";
/* Opt-in list-screen skin: only screens carrying `.o-list` are affected. */
@import "./app_css/list-screen.scss";
/* Leads (Agent LOS) layer on top of it; scoped under `.o-leads`. */
@import "./app_css/leads.scss";
/* LOS lead list — same anatomy as Leads; scoped under `.o-los`. */
@import "./app_css/los.scss";
/* LMS loan book — same anatomy again, plus the money-cell rules only a
   servicing table needs; scoped under `.o-lms`. */
@import "./app_css/lms.scss";
/* LMS loan DETAIL (the Loan Schedule tab) — fifteen scalar columns folded into
   eight composites, pixel-sized and scrolling; scoped under `.o-lmsd`. */
@import "./app_css/lms-detail.scss";
/* Collections — the segment strip, the fixed table with its two-line header
   band, and the money/charge/DPD cell vocabulary; scoped under
   `.o-collections`. Imported AFTER the other screen skins: it was first in the
   list, so any rule it shared at equal specificity with `.o-leads`-era globals
   lost on source order. */
@import "./app_css/collections.scss";
/* Accounts (ledger) — the book of record: right-aligned tabular figures, a
   closing-balance plate and a single-line row; scoped under `.o-acct`. */
@import "./app_css/accounts.scss";
/* Payments — the receipts book: composite customer cell, AA-passing status
   tags and a navy tab strip in place of the pre-flip blue; under `.o-pay`. */
@import "./app_css/payments.scss";
/* Reports — the generated-file queue and its templates; under `.o-rep`. */
@import "./app_css/reports.scss";
/* Create-lead stepper: one Back/Next action group for every product's steps. */
@import "./app_css/create-lead.scss";
/* Dialogs + tooltips. Global: an overlay renders outside every screen's scope
   but must not look like it came from a different application. */
@import "./app_css/dialog.scss";
/* LOS lead-detail workflow; scoped under `.o-detail`. */
@import "./app_css/detail.scss";
/* Borrower record (the "Borrower Details" tab, mounted by BOTH the LOS lead
   detail and the LMS loan detail) — numbered rail + tinted section panels, the
   same shape as the loan-scheme editor; scoped under `.o-rec`. */
@import "./app_css/record.scss";
/* Borrower Eligibility / "Verification Details" dialog — the same numbered rail
   + tinted section panels as the record above, sized for a dialog instead of a
   tab; scoped under `.o-vdlg`. Global because a v-dialog's content is moved to
   the app root, outside the mounting screen's scope. */
@import "./app_css/verification-dialog.scss";

// Team — second adopter of the .o-list skin.
@import "./app_css/team.scss";
/* Permission editor + Permission Groups screens. Global for the same reason:
   <PermissionEditor> is mounted by the group editor, Team and Dealer records. */
@import "./app_css/access.scss";
/* Partner (DSA) portal skin -- everything scoped under `.pp`. */
@import "./app_css/partner-portal.scss";
/* *{
  font-family: "Gotham", system-ui, -apple-system, BlinkMacSystemFont,
    "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue",
    sans-serif;
}
*/
::-webkit-scrollbar {
  width: 5px;
  height: 7px;
}

::-webkit-scrollbar-track {
  background: #bdbdbd;
}

::-webkit-scrollbar-thumb {
  background-color: #183048;
  border-radius: 20px;
}
::-webkit-scrollbar:hover {
  width: 8px;
  height: 10px;
  z-index: 5;
}

::-webkit-scrollbar-track:hover {
  background: #bdbdbd;
  z-index: 6;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  margin: 0;
}

button {
  text-transform: capitalize !important;
}

/* Keep the clearable (×) icon always visible whenever a field holds a value,
   instead of Vuetify's default reveal-on-hover. This makes every applied
   filter's clear cross stay visible on all list pages (so it no longer
   "hides" when another filter is set). Vuetify only renders this element
   when the field is dirty, so empty fields are unaffected. */
.v-input__icon--clear {
  opacity: 1 !important;
}
</style>
<style lang="sass">
@import "./app_css/variables.sass"
</style>
